'use strict';

var escape = require('lodash.escape');

module.exports = function eskape(strs) {
	var out = strs[0];

	for (var _len = arguments.length, vals = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		vals[_key - 1] = arguments[_key];
	}

	for (var i = 0; i < vals.length; i++) {
		out = out + escape(vals[i]) + strs[i + 1];
	}

	return out;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/eskape/index.js
// module id = 508
// module chunks = 0